export function readCurrentStoreLocation() {
  return new Promise((resolve, reject) => {
    if (typeof navigator === 'undefined' || !navigator.geolocation) {
      reject(Object.assign(new Error('Location is not supported'), { code: 'location/unsupported' }))
      return
    }
    navigator.geolocation.getCurrentPosition((position) => {
      const { latitude, longitude, accuracy } = position?.coords || {}
      const timestamp = position?.timestamp
      if (![latitude, longitude, accuracy, timestamp].every(Number.isFinite) || Math.abs(latitude) > 90 || Math.abs(longitude) > 180 || accuracy <= 0) {
        reject(Object.assign(new Error('Invalid location reading'), { code: 'location/invalid' }))
        return
      }
      resolve({ latitude, longitude, accuracy, timestamp })
    }, reject, { enableHighAccuracy: true, maximumAge: 0, timeout: 15000 })
  })
}

export function storeLocationErrorMessage(error) {
  if (error?.code === 1) return 'Allow location access for this app in your browser or iPhone settings, then try again.'
  if (error?.code === 3) return 'Location took too long. Move near a window or outdoors and try again.'
  if (error?.code === 'location/unsupported') return 'Location is unavailable in this browser. Open the portal in Safari or a supported browser and try again.'
  return 'Your location could not be read. Check that Location Services are enabled and try again.'
}
